import api from 'api';

export const loadLinksLocales = api('GET /api/campaigns/links/locales');

export const loadLinksLandings = api('GET /api/campaigns/links/landings');

export const generateLinks = api('POST /api/campaigns/:id/links');

export const exportLinks = api('GET /api/campaigns/links-export', {
  responseType: 'blob',
});
